// extracted by mini-css-extract-plugin
module.exports = {"loadingGrid":"SchedulerWebViewConfig_loadingGrid__2kkGN","loadingText":"SchedulerWebViewConfig_loadingText__2ejnt"};